import { Component, Inject } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-template-dialog',
  templateUrl: './template-dialog.component.html',
  styleUrls: ['./template-dialog.component.css']
})
export class TemplateDialogComponent {
  htmlContent: SafeHtml;
  html:any;
  constructor(
    public dialogRef: MatDialogRef<TemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { htmlContent: string },
    private sanitizer: DomSanitizer // Inject DomSanitizer
  ) {
    var a= data.htmlContent;

    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(a || "");
  }
 onClose(): void {
   this.dialogRef.close();
  }
}